import { render, staticRenderFns } from "./cardBottom.vue?vue&type=template&id=0b81392f&scoped=true"
import script from "./cardBottom.vue?vue&type=script&lang=js"
export * from "./cardBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b81392f",
  null
  
)

export default component.exports